import { render, staticRenderFns } from "./Calculator.vue?vue&type=template&id=7aba7663&"
import script from "./Calculator.vue?vue&type=script&lang=js&"
export * from "./Calculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CTextarea: require('@chakra-ui/vue').CTextarea, CHeading: require('@chakra-ui/vue').CHeading, CText: require('@chakra-ui/vue').CText, CBox: require('@chakra-ui/vue').CBox})
